<template>
  <div class="u-shareBox">
    <div class="shareBox-wrap" v-if="toShow" @click="noShow">
      <img src="../../assets/share_img.png" class="shareImg">
    </div>
  </div>
</template>

<script>
export default {
  name: 'u-shareBox',
  data () {
    return {
      toShow: false
    }
  },
  props: {},
  methods: {
    show () {
      this.toShow = true
    },
    noShow () {
      this.toShow = false
    }
  }
}
</script>

<style lang="scss" scoped>
.u-shareBox{
}
.shareBox-wrap{
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.7);
  z-index: 3;
  .shareImg{
    position: absolute;
    width:408px;
    height: auto;
    right: 30px;
    top: 20px;
  }
}
</style>
